__turbopack_context__.v({
  "button": "iTJoXW_button",
  "isDisabled": "iTJoXW_isDisabled",
  "loader": "iTJoXW_loader",
  "userIcon": "iTJoXW_userIcon",
});
